import { supabase } from '../lib/supabase';

export const userService = {
  async getAllUsers() {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.order('created_at', { ascending: false });
    
    if (error) throw error;
    
    // Convert snake_case to camelCase
    return data?.map(user => ({
      id: user?.id,
      email: user?.email,
      fullName: user?.full_name,
      role: user?.role,
      isActive: user?.is_active,
      createdAt: user?.created_at,
      updatedAt: user?.updated_at
    }));
  },

  async getUserById(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      email: data?.email,
      fullName: data?.full_name,
      role: data?.role,
      isActive: data?.is_active,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  async updateUser(userId, updates) {
    // Convert camelCase to snake_case for DB
    const dbUpdates = {};
    if (updates?.fullName !== undefined) dbUpdates.full_name = updates?.fullName;
    if (updates?.role !== undefined) dbUpdates.role = updates?.role;
    if (updates?.isActive !== undefined) dbUpdates.is_active = updates?.isActive;

    const { data, error } = await supabase?.from('user_profiles')?.update(dbUpdates)?.eq('id', userId)?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      email: data?.email,
      fullName: data?.full_name,
      role: data?.role,
      isActive: data?.is_active,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  async deleteUser(userId) {
    const { error } = await supabase?.from('user_profiles')?.delete()?.eq('id', userId);
    
    if (error) throw error;
  },

  async getClientUsers() {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('role', 'cliente')?.eq('is_active', true)?.order('full_name', { ascending: true });
    
    if (error) throw error;
    
    return data?.map(user => ({
      id: user?.id,
      email: user?.email,
      fullName: user?.full_name,
      role: user?.role,
      isActive: user?.is_active
    }));
  }
};